<template>
    <div class="payable-receivable-summary-mock">
        <button v-if="!open" class="payable-receivable-summary-mock-button" type="button" @click="toggleSummary">
            <i class="fa-solid fa-wallet"></i>
        </button>

        <transition name="payable-receivable-summary-mock-slide-up">
            <div v-if="open" class="payable-receivable-summary-mock-panel">
                <div class="payable-receivable-summary-mock-header">
                    <span>Resumo Financeiro</span>
                    <button type="button" class="payable-receivable-summary-mock-close" @click="toggleSummary">
                        <i class="fa-solid fa-xmark"></i>
                    </button>
                </div>

                <div class="payable-receivable-summary-mock-body">
                    <div class="payable-receivable-summary-mock-item">
                        <span class="payable-receivable-summary-mock-label">Saldo</span>
                        <span class="payable-receivable-summary-mock-value" :class="valueClass(prevBalance)">
                            {{ prevBalance | currency }}
                        </span>
                    </div>

                    <div class="payable-receivable-summary-mock-item">
                        <span class="payable-receivable-summary-mock-label">Total a pagar</span>
                        <span class="payable-receivable-summary-mock-value payable-receivable-summary-mock-negative">
                            {{ totalPagar | currency }}
                        </span>
                    </div>

                    <div class="payable-receivable-summary-mock-item">
                        <span class="payable-receivable-summary-mock-label">Total a receber</span>
                        <span class="payable-receivable-summary-mock-value payable-receivable-summary-mock-positive">
                            {{ totalReceber | currency }}
                        </span>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>

export default {
    name: "PayableReceivableSummary",
    props: {
        prevBalance: { type: Number, default: 0 },
        totalPagar: { type: Number, default: 0 },
        totalReceber: { type: Number, default: 0 },
        balanceType: { type: String, default: "neutral" },
    },
    data() {
        return {
            open: false,
        };
    },
    methods: {
        toggleSummary() {
            this.open = !this.open;
        },
        valueClass(value) {
            const numberValue = Number(value) || 0;
            if (numberValue < 0) return "payable-receivable-summary-mock-negative";
            if (numberValue > 0) return "payable-receivable-summary-mock-positive";
            return "payable-receivable-summary-mock-neutral";
        },

    },
};
</script>

<style scoped>
.payable-receivable-summary-mock-button {
    position: fixed;
    right: 26px;
    bottom: 20px;
    width: 46px;
    height: 46px;
    border: none;
    border-radius: 999px;
    background: var(--color-warning);
    color: var(--text-inverse);
    font-size: 18px;
    cursor: pointer;
    z-index: 11;
    transition: background 0.2s;
}

.payable-receivable-summary-mock-button:hover {
    background: var(--color-warning);
}

.payable-receivable-summary-mock-panel {
    position: fixed;
    right: 28px;
    bottom: 20px;
    width: 350px;
    border: 1px solid var(--border-color);
    border-radius: 12px;
    background-color: var(--bg-base);
    overflow: hidden;
    box-shadow: var(--shadow-md);
    z-index: 11;
}

.payable-receivable-summary-mock-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 14px;
    color: var(--text-primary);
    font-size: 15px;
    font-weight: 600;
}

.payable-receivable-summary-mock-close {
    border: none;
    background: transparent;
    color: var(--text-secondary);
    font-size: 18px;
    line-height: 1;
    cursor: pointer;
    transition: color 0.2s;
}

.payable-receivable-summary-mock-close:hover {
    color: var(--text-primary);
}

.payable-receivable-summary-mock-body {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 14px;
    margin-right: 15px;
    margin-left: 15px;
    border-top: 1px solid var(--border-subtle);
}

.payable-receivable-summary-mock-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
}

.payable-receivable-summary-mock-label {
    color: var(--text-secondary);
}

.payable-receivable-summary-mock-value {
    font-weight: 700;
}

.payable-receivable-summary-mock-positive {
    color: var(--color-success);
}

.payable-receivable-summary-mock-negative {
    color: var(--color-danger);
}

.payable-receivable-summary-mock-neutral {
    color: var(--color-brand-dark);
}

.payable-receivable-summary-mock-slide-up-enter-active,
.payable-receivable-summary-mock-slide-up-leave-active {
    transition: opacity 0.25s, transform 0.25s;
}

.payable-receivable-summary-mock-slide-up-enter,
.payable-receivable-summary-mock-slide-up-leave-to {
    opacity: 0;
    transform: translateY(20px);
}

@media (max-width: 768px) {
    .payable-receivable-summary-mock-panel {
        right: 12px;
        left: 12px;
        width: auto;
    }

    .payable-receivable-summary-mock-button {
        right: 16px;
    }
}
</style>